import React from 'react'
import classNames from 'classnames'
import { ButtonSize, getButtonSizeClasses } from '@/atoms/Button/ButtonUtil'
import { useDerivedAriaLabel } from '@/utils/reactUtils/reactChildrenUtils'
import { ButtonVariant, getVariantClasses } from './ButtonUtil'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonVariant
  size?: ButtonSize
  outline?: boolean
  danger?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { variant, size = 'standard', outline, className, children, danger, ...rest } = props
  const ariaLabel = useDerivedAriaLabel(props)

  return (
    <button
      {...rest}
      ref={ref}
      className={
        variant === 'plain'
          ? className
          : classNames(
              'btn',
              getButtonSizeClasses(size),
              getVariantClasses({ variant, outline, disabled: props.disabled, danger }),
              className,
            )
      }
      aria-label={ariaLabel}
    >
      {children}
    </button>
  )
})

Button.displayName = 'Button'
